import { createTheme } from "@mui/material";
import { blue, purple, red} from "@mui/material/colors";
import darkScrollbar from '@mui/material/darkScrollbar';
import { letterSpacing } from "@mui/system";

const Theme = createTheme({
    palette: {
        primary: {
            main: "rgba(197, 165, 114, 0.6)",
            light: "rgba(17, 152, 38, 1)"
        },

        secondary: {
            main: "#FEFEFE",
            light: red[800],
            dark: "#FEFEFE",
        },
        
        success: {
            main: purple[500],
        },

        error: {
            main: "#CC0000",
            light: "#CC0000",
            dark: "#CC0000",
        },

        special: {
            main: "rgba(0, 0, 0, 0.4)",
            light: "rgba(0, 0, 0, 0.6)"
        },
        
        search: {
            main: "#C5A572",
            light: "#C5A572"
        },
    },

    components: {
        MuiButton: {
            styleOverrides: {
                textPrimary: {
                    main: blue[500],
                    light: blue[500],
                    dark: blue[500],
                },

                containedPrimary: {
                    main: blue[500],
                    light: blue[500],
                    dark: blue[500],
                },
            }
        },

        MuiCssBaseline: {
            styleOverrides: {
                '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
    backgroundColor: "transparent"
  },
  '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
    borderRadius: 20,
    backgroundColor: "blue",
    minHeight: 24,
    // border: string
  },
  '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus': {
    backgroundColor: "blue"
  },
  '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active': {
    backgroundColor: "blue"
  },
  '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover': {
    backgroundColor: "blue"
  },
  '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
    backgroundColor: "transparent"
  }
            },
        },

        MuiFab: {
            styleOverrides: {
                root: {
                    backgroundColor: "black",
                }
            }
        },

        MuiTypography: {
            styleOverrides: {
                root: {
                    fontFamily: '"Open Sans", sans-serif',
                },
                indexHeroH1: {
                    color: "#2C251E",
                    fontSize: "50px",
                    fontWeight: "bold",
                    padding: "5px 10px",
                },
                indexHeroH2: {
                    color: "#C5A572",
                    fontSize: "30px",
                    fontWeight: "bold",
                    padding: "5px 10px",
                },
                indexHeroH3: {
                    color: "#59544A",
                    fontSize: "17px",
                    fontWeight: "300",
                    padding: "5px 10px",
                },
                patientNameRecords: {
                    color: "#2C251E",
                    fontSize: "17px",
                    fontWeight: "600",
                    padding: "5px 10px",
                },
                indexLearnMore: {
                    color: "#C5A572",
                    fontSize: "14px",
                    fontWeight: "300",
                    padding: "5px 10px",
                },
                otherPagesH1: {
                    color: "#FEFEFE",
                    fontSize: "36px",
                    fontWeight: "bold",
                    // padding: "5px 10px",
                },
                otherPagesH2: {
                    color: "rgba(253, 249, 243, 0.70)",
                    fontSize: "24px",
                    fontWeight: "300",
                    // padding: "",
                    // backgroundColor: "mediumaquamarine"
                },
                indexH3: {
                    color: "#C5A572",
                    fontSize: "17px",
                    fontWeight: "600",
                },
                insuranceH3: {
                    color: "#2C251E",
                    fontSize: "24px",
                    fontWeight: "600",
                },
                h1: {
                    color: "#2C251E",
                    fontSize: "50px",
                    fontWeight: "bold",
                    padding: "5px 10px",
                },
                headerh1: {
                    color: "#2C251E", 
                    // border: "1px solid black",
                    fontSize: "24px",
                    padding: "15px 10px",
                    fontWeight: "bold", 
                },
                headerh1DarkMode: {
                    color: "#FEFEFE", 
                    // border: "1px solid black",
                    fontSize: "20px",
                    padding: "15px 10px",
                    fontWeight: "bold",
                    letterSpacing: 0.4 
                },
                serviceTitle: {
                    color: "#2C251E", 
                    fontSize: "24px",
                    padding: "15px 10px",
                    fontWeight: "bold", 
                },
                serviceTitleNoMargin: {
                    color: "#2C251E", 
                    fontSize: "24px",
                    fontWeight: "bold", 
                },
                overlayTime: {
                    color: "rgba(46, 45, 45, 1)", 
                    fontSize: "24px",
                    padding: "15px 10px",
                    fontWeight: "bold", 
                },
                overlayTimeDef: {
                    color: "#59544A", 
                    fontSize: "16px",
                    padding: "15px 10px",
                    // fontWeight: "bold", 
                },
                selectAll: {
                    color: "#59544A", 
                    fontSize: "16px",
                    // fontWeight: "bold", 
                },
                serviceSubtitle: {
                    color: "#59544A", 
                    fontSize: "17px",
                    padding: "15px 10px",
                    fontWeight: "300", 
                },
                serviceSubtitleNoMargin: {
                    color: "#59544A", 
                    fontSize: "17px",
                    fontWeight: "300", 
                },
                serviceTableLable: {
                    color: "#FDF9F3", 
                    fontSize: "17px",
                    // padding: "15px 10px",
                    fontWeight: "600", 
                    letterSpacing: 0.3
                },
                headerh2: {
                    color: "#2C251E",
                    // border: "1px solid black",
                    fontSize: "20px",
                    padding: "15px 0",
                    fontWeight: "bold",
                },
                patientRecordName: {
                    color: "#2C251E",
                    // border: "1px solid black",
                    fontSize: "20px",
                    padding: "15px 0",
                    fontWeight: "bold",
                    letterSpacing: -0.3
                },
                success: {
                    color: "#558363",
                    // border: "1px solid black",
                    fontSize: "20px",
                    padding: "15px 0",
                    fontWeight: "bold",
                },
                bookModal: {
                    color: "#FDF9F3",
                    // border: "1px solid black",
                    fontSize: "14px",
                    padding: "5px 5px",
                    // fontWeight: "bold",
                },
                bookModalLight: {
                    color: "#C5A572",
                    // border: "1px solid black",
                    fontSize: "14px",
                    padding: "5px 5px",
                    // fontWeight: "bold",
                },
                testimonialsH3: {
                    color: "#2C251E",
                    fontSize: "14px",
                    fontWeight: "600",
                },
                manageName: {
                    color: "#2C251E",
                    fontSize: "15px",
                    fontWeight: "600",
                },
                termsTitle: {
                    color: "#2C251E",
                    fontSize: "16px",
                    fontWeight: "600",
                    fontFamily: "Roboto"
                },
                accDentistTitle: {
                    color: "#FDF9F3",
                    fontSize: "17px",
                    fontWeight: "200",
                    fontFamily: "Roboto"
                },
                manageListName: {
                    color: "#2C251E",
                    fontSize: "17px",
                    fontWeight: "600",
                },
                manageListBold: {
                    color: "#2C251E",
                    fontSize: "14px",
                    fontWeight: "600",
                },
                manageListRegular: {
                    color: "#2C251E",
                    fontSize: "14px",
                    fontWeight: "100",
                },
                manageListPending: {
                    color: "rgba(180, 153, 108, 1)",
                    fontSize: "14px",
                    fontWeight: "600",
                },
                manageListConfirmed: {
                    color: "rgba(67, 103, 78, 1)",
                    fontSize: "14px",
                    fontWeight: "600",
                },
                manageListCompleted: {
                    color: "rgba(44, 103, 133, 1)",
                    fontSize: "14px",
                    fontWeight: "600",
                },
                termsContent: {
                    color: "#59544A",
                    fontSize: "14px",
                    fontWeight: "300",
                    fontFamily: "Roboto"
                },
                termsImportant: {
                    color: "#9F4223",
                    fontSize: "14px",
                    fontWeight: "600",
                    fontFamily: "Roboto"
                },
                manageType: {
                    color: "#C5A572",
                    fontSize: "14px",
                    fontWeight: "500",
                },
                manageDoc: {
                    color: "#59544A",
                    fontSize: "14px",
                    fontWeight: "500",
                },
                removePersonnel: {
                    color: "#9F4223",
                    fontSize: "14px",
                    fontWeight: "500",
                },
                removePersonnelHover: {
                    color: "#FDF9F3",
                    fontSize: "14px",
                    fontWeight: "500",
                },
                servicesCost: {
                    color: "#2C251E",
                    fontSize: "14px",
                    fontWeight: "600",
                    letterSpacing: ".5px",
                },
                contactHours: {
                    color: "#C5A572",
                    fontSize: "14px",
                    fontWeight: "600",
                },
                historyService: {
                    color: "#2C251E",
                    fontSize: "17px",
                    fontWeight: "600",
                    padding: "10px"
                },
                settingsEmail: {
                    color: "#59544A",
                    fontSize: "14px",
                    fontWeight: "300",
                    padding: "10px"
                },
                signUpModalText: {
                    color: "#59544A",
                    fontSize: "14px",
                    fontWeight: "300",
                },
                signUpModalResend: {
                    color: "#2C6785",
                    fontSize: "14px",
                    fontWeight: "600",
                    padding: "0 4px"
                },
                signUpModalResendDisabled: {
                    color: "#2c251e",
                    fontSize: "14px",
                    fontWeight: "600",
                    padding: "0 4px",
                    opacity: 0.3
                },
                historyDateTime: {
                    color: "#2C251E",
                    fontSize: "14px",
                    fontWeight: "300",
                    padding: "10px"
                },
                serviceBoldTitle: {
                    color: "#2C251E",
                    fontSize: "14px",
                    fontWeight: "600",
                    padding: "10px"
                },
                appointmentLabels: {
                    color: "#FEFEFE",
                    fontSize: "14px",
                    fontWeight: "300",
                    padding: "10px 10px 10px 0"
                },
                importantTitle: {
                    color: "#2C251E",
                    fontSize: "14px",
                    fontWeight: "600",
                },
                importantLabel: {
                    color: "#2C251E",
                    fontSize: "12px",
                    fontWeight: "400",
                },
                importantLabelBold: {
                    color: "#2C251E",
                    fontSize: "12px",
                    fontWeight: "600",
                },
                importantLabelLight: {
                    color: "#2C251E",
                    fontSize: "12px",
                    fontWeight: "400",
                },
                importantLabelItalic: {
                    color: "#FDF9F3",
                    fontSize: "11px",
                    fontWeight: "600",
                    fontStyle: "italic"
                },
                timeSlotReserved: {
                    color: "#FEFEFE",
                    fontSize: "14px",
                    fontWeight: "300",
                    padding: "10px"
                },
                historyRemarks: {
                    color: "#2C251E",
                    fontSize: "14px",
                    fontWeight: "300",
                },
                historyContent: {
                    color: "#2C251E",
                    fontSize: "14px",
                    fontWeight: "600",
                },
                historyLabels: {
                    color: "rgba(44, 37, 30, 0.7)",
                    fontSize: "14px",
                    fontWeight: "300",
                },
                serviceLabels: {
                    color: "rgba(44, 37, 30, 0.7)",
                    fontSize: "14px",
                    fontWeight: "300",
                    padding: "10px"
                },
                successfullAlert: {
                    color: "#2C251E",
                    fontSize: "17px",
                    fontWeight: "300",
                    letterSpacing: ".3px",
                },
                h2: {
                    color: "#2C251E",
                    fontSize: "30px",
                    fontWeight: "bold",
                    padding: "5px 10px",
                },
                h3: {
                    color: "#2C251E",
                    fontSize: "17px",
                    fontWeight: "600",
                },
                notificationH3: {
                    color: "#2C251E",
                    fontSize: "14px",
                    fontWeight: "600",
                    fontFamily: "Inter"
                    // letterSpacing: .8
                },
                notificationNumber: {
                    color: "#9F4223",
                    fontSize: "14px",
                    fontWeight: "600",
                },
                medicalHistoryNotice: {
                    color: "#9F4223",
                    fontSize: "14px",
                    fontWeight: "100",
                },
                h3Header: {
                    fontWeight: "300",
                    padding: "5px 10px",
                    fontSize: "14px",
                    alignContent: "center",
                },
                h3HeaderBold: {
                    fontWeight: "600",
                    padding: "5px 10px",
                    fontSize: "14px",
                    alignContent: "center",
                },
                h4: {
                    color: "#FDF9F3",
                    fontSize: "17px",
                },
                h4Light: {
                    color: "#FDF9F3",
                    fontSize: "17px",
                },
                h4Dark: {
                    color: "#2C251E",
                    fontSize: "17px",
                    fontFamily: "Inter",
                    fontWeight: "600",
                    letterSpacing: 0.2
                },
                h5: {
                    color: "#FDF9F3",
                    fontSize: "14px",
                    opacity: "0.5"
                },
                body1: {
                    color: "#59544A",
                    fontSize: "14px",
                    fontWeight: "300",
                },
                body2: {
                    color: "#FDF9F3",
                    fontSize: "14px",
                    opacity: 0.5,
                    fontWeight: "300",
                },
                body3: {
                    color: "#FEFEFE",
                    fontSize: "12px",
                    fontWeight: "300",
                    letterSpacing: 0.2
                },
                signout: {
                    color: "#FDF9F3",
                    fontWeight: "300",
                    fontSize: "14px",
                    padding: "10px 15px",
                    transition: "font-size 0.2s",
                },
                signoutButton: {
                    color: "#FDF9F3",
                    fontWeight: "300",
                    fontSize: "14px",
                    padding: "10px 15px 10px 10px",
                },
                personnel: {
                    color: "#FDF9F3",
                    fontWeight: "300",
                    fontSize: "14px",
                    padding: "10px 15px 10px 5px",
                    transition: "font-size 0.2s",
                },
                spacer: {
                    color: "transparent",
                    fontSize: "14px",
                    fontWeight: "300",
                }
            }
        },

        MuiRating: {
            styleOverrides: {
                iconFilled: {
                color: "#C5A572 !important",
                },
                iconHover: {
                color: "#C5A572 !important",
                },
                iconEmpty: {
                color: "#C5A572 !important",
                opacity: 0.4,
                },
            }
        }
    }
});

export default Theme;